import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import CategoryHeader from './components/CategoryHeader';
import CategoryGrid from './components/CategoryGrid';

const wpJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: '韩漫分类浏览 - 韩漫漫画网',
  description: '浏览韩漫漫画网全部漫画分类，涵盖奇幻冒险、恋爱言情、悬疑惊悚、玄幻仙侠、校园青春、科幻末世、都市职场、历史古风等八大品类。',
  url: 'http://ihua3.com/category',
};

export default function CategoryPage() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(wpJsonLd)}</script>
      <SEOHead
        title="韩漫分类_漫画类型大全_韩国漫画分类浏览-韩漫漫画网"
        description="浏览韩漫漫画网全部漫画分类，涵盖奇幻冒险、恋爱言情、悬疑惊悚、玄幻仙侠、校园青春、科幻末世、都市职场、历史古风等八大品类，快速找到你喜欢的韩国漫画。"
        keywords="韩漫分类,漫画类型,韩国漫画分类,韩漫漫画网"
        canonicalUrl="http://ihua3.com/category"
      />
      <Navbar />
      <main className="pt-16">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-4">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '分类浏览' },
            ]}
          />
        </div>
        <CategoryHeader />
        <CategoryGrid />
      </main>
      <Footer />
    </>
  );
}